/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment } from 'react';

import Button from '@atlaskit/button/new';
import { cssMap, cx, jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
export type CharlieTableLoadMoreProps = {
	hasNext: boolean | null | undefined;
	onLoadNext: (() => void) | null | undefined;
	isLoading: boolean;
	isEmptyState: boolean;
	isError: boolean;
	hidePaginationEndIndicator?: boolean;
	loadMoreLabel: string;
	loadMore: string;
};

const styles = cssMap({
	LoadMoreWrapperStyle: { marginBlockStart: token('space.100') },
	LoadMoreContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'sticky',
		left: token('space.0'),
	},
	LoadMoreContainerDisabled: {
		pointerEvents: 'none',
	},
	EndIndicatorDivider: {
		border: 'none',
		borderBottom: `${token('border.width.selected')} solid ${token('color.border')}`,
		marginTop: token('space.250'),
		width: '10%',
	},
});

export const LoadMore = ({
	hasNext,
	onLoadNext,
	isLoading,
	isEmptyState,
	isError,
	hidePaginationEndIndicator,
	loadMoreLabel,
	loadMore,
}: CharlieTableLoadMoreProps): React.JSX.Element | null => {
	if (hasNext == null || onLoadNext == null) {
		return null;
	}

	const shapeThemeRefresh = fg('charlie-table-shape-refresh');

	return !shapeThemeRefresh ? (
		<Inline xcss={cx(styles.LoadMoreContainer, !hasNext && styles.LoadMoreContainerDisabled)}>
			{hasNext && onLoadNext ? (
				<Box xcss={styles.LoadMoreWrapperStyle}>
					<Button
						testId="prev-page-test-id"
						isLoading={isLoading}
						onClick={() => {
							onLoadNext();
						}}
						aria-label={loadMoreLabel}
						spacing="compact"
					>
						{loadMore}
					</Button>
				</Box>
			) : (
				<Fragment>
					{!(isEmptyState || isError || hidePaginationEndIndicator) && (
						<Box
							as="hr"
							testId="table-footer-divider"
							xcss={styles.EndIndicatorDivider}
							role="presentation"
						/>
					)}
				</Fragment>
			)}
		</Inline>
	) : null;
};
